import { CheckCircledIcon } from "@radix-ui/react-icons";
import { Card, Container, Heading, Text } from "@radix-ui/themes";

interface Props {
    userEmail?: string;
    deviceName?: string;
}

export default function DeviceVerifiedSuccessView({ userEmail, deviceName }: Props) {
    return (
        <Container size="1" p="4">
            <Card
                size="4"
                style={{
                    maxWidth: 500,
                    margin: "0 auto",
                    textAlign: "center",
                    padding: "40px 20px",
                }}
            >
                <div
                    style={{
                        marginBottom: 20,
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <CheckCircledIcon width="64" height="64" color="var(--accent-9)" />
                </div>

                <Heading
                    size="6"
                    mb="4"
                    style={{
                        color: "var(--accent-9)",
                    }}
                >
                    Device Verified Successfully
                </Heading>

                <Text as="p" size="3" color="gray" mb="2">
                    Your device <strong>{deviceName}</strong> has been verified for
                </Text>

                <Text
                    as="p"
                    size="4"
                    weight="bold"
                    mb="6"
                    style={{
                        color: "white",
                    }}
                >
                    {userEmail}
                </Text>

                <Text as="p" size="2" color="gray" mb="6">
                    Close this window and complete the connector setup if you haven’t done it yet.
                </Text>
            </Card>
        </Container>
    );
}
